// import { locale } from 'bv-i18n';
// Can't import from bv-i18n as bv-i18n is not loaded yet.
// Will be fixed once this JS is moved to utils (frontend webpacker)
import { locale } from 'state';

export default (format) => (unixTime) => (new Date(unixTime))
  .toLocaleDateString(locale(), format);
